import { useEffect, useState } from 'react'
import { store } from 'redux/store/Store'
import { filterUrls } from 'services/api.enums'
import { filterDataAPIv1 } from 'services/CRUDServices'
import { getToday } from 'tools/functions/Methods'

const useFetchJobs = (toggle: boolean) => {
  const { token } = store.getState().authenticate
  const [jobs, setJobs] = useState<any[]>([])
  const [loadingJob, setLoadingJob] = useState(false)

  const fetchData =async () => {

      try {
        setLoadingJob(true)
        const response = await filterDataAPIv1(
          filterUrls.getJobs,
          {
            createdDate: {
              from: {
                ...getToday(true),
                hour: 0,
                minute: 0,
              },
              to: {
                ...getToday(true),
                hour: 23,
                minute: 59,
              },
            },
          },
          1,
          10,
          [
            {
              property: 'createdDate',
              direction: 'DESC',
            },
          ]
        )
        setJobs(response.data.response.items)
      } catch (error) {
        setLoadingJob(false)
      } finally {
        setLoadingJob(false)
      }
    
  }
  useEffect(() => {
    if (!token || !toggle) return

    fetchData()
    const intervalId = setInterval(fetchData, 5000)

    return () => clearInterval(intervalId)
  }, [token, toggle])
  return { jobs, loadingJob,fetchData }
}

export default useFetchJobs
